module.exports = __webpack_public_path__ + "img/logo-english.f4292b78.png";